/**
 * Handles all toggles suchs as main controls secondary tabs and content
 * @returns null or creates class
 */
function doCollectionCta() {
  if (customElements.get("collection-cta")) return null;

  class CollectionCta extends HTMLElement {
    constructor() {
      super();
      this.tab1Trigger = this.querySelector(
        `.tabControls-main a[data-tab="1"]`
      );
      this.tab2Trigger = this.querySelector(
        `.tabControls-main a[data-tab="2"]`
      );
      this.mainControls = this.querySelectorAll(".tabControls-main a");

      this.secondaryNavForTab1 = this.querySelector(
        `.tabControls-secondary[data-tab="tab1"]`
      );
      this.secondaryNavForTab2 = this.querySelector(
        `.tabControls-secondary[data-tab="tab2"]`
      );
      this.allSecondaryControls = this.querySelectorAll(
        ".tabControls-secondary"
      );
      this.allSecondaryTabs = this.querySelectorAll(".tabControls-secondary a");
      this.allContent = this.querySelectorAll(".snippet-productsAndCta");
      this.init();
    }

    init() {
      this.initSwiper();
      // handle mainControls
      this.mainControls.forEach((mainControl) => {
        mainControl.addEventListener("click", (e) => {
          e.preventDefault();
          const secondaryControlToShow = this.querySelector(
            `.tabControls-secondary[data-tab="tab${mainControl.dataset.tab}"]`
          );
          const firstItemInThisSecondaryTabz =
            secondaryControlToShow.querySelector("li a").dataset.title;
          const contentToShow = this.querySelector(
            `.snippet-productsAndCta[data-belongs-to="${firstItemInThisSecondaryTabz}"]`
          );

          this.deactivateAllMainControls(mainControl);
          mainControl.setAttribute("data-status", 1);
          this.hideAllSecondaryTabs();
          this.toggleSecondaryControl(secondaryControlToShow, "show");
          this.deactivateAllSecondaryTabs();
          this.toggleSecondaryTabActiveness(
            secondaryControlToShow.querySelector("li a"),
            "enable"
          );
          this.hideAllContent();
          this.toggleContent(contentToShow, "show");
        });
      });

      // handle secondaryTabs
      this.allSecondaryTabs.forEach((secondaryTab) => {
        secondaryTab.addEventListener("click", (e) => {
          e.preventDefault();
          const thisContentToShow = this.querySelector(
            `.snippet-productsAndCta[data-belongs-to="${secondaryTab.dataset.title}"]`
          );
          this.deactivateAllSecondaryTabs();
          this.toggleSecondaryTabActiveness(secondaryTab, "enable");
          this.hideAllContent();
          this.toggleContent(thisContentToShow, "show");
        });
      });
    }

    initSwiper() {
      const swiper = new Swiper(
        ".section-collectionCta .productsAndCta-slider",
        {
          // Optional parameters
          direction: "horizontal",
          loop: false,
          autoHeight: false,
          slidesPerView: 1,
          spaceBetween: 10,
          autoplay: 5000,
          navigation: {
            nextEl: ".productsAndCta-carousel-next",
            prevEl: ".productsAndCta-carousel-prev",
          },
          breakpoints: {
            989: {
              spaceBetween: 20,
              slidesPerView: 2,
              slidesPerView: "auto",
            },
          },
        }
      );
    }
    /**
     *
     * @param {HTML Element} element
     * @param {String} action ['hide','show']
     * @returns
     */
    toggleSecondaryControl(element, action = "show") {
      if (action === "hide") {
        element.setAttribute("data-status", 0);
        return;
      }
      element.setAttribute("data-status", 1);
    }

    /**
     *
     * @param {HTML Element} element
     * @param {String} action ['enable','disable']
     * @returns
     */
    toggleMainControl(element, action = "enable") {
      if (action === "disable") {
        element.setAttribute("data-status", 0);
        return;
      }

      element.setAttribute("data-status", 1);
    }

    /**
     *
     * @param {HTML Element} element
     * @param {String} action ['hide','show']
     * @returns
     */
    toggleContent(element, action = "hide") {
      if (action === "hide") {
        element.style.opacity = 0;
        element.setAttribute("data-status", 0);

        return;
      }

      element.setAttribute("data-status", 1);
      setTimeout(() => (element.style.opacity = 1), 100);
    }

    /**
     *
     * @param {HTML Element} element
     * @param {String} action ['enable','disable']
     * @returns
     */
    toggleSecondaryTabActiveness(element, action = "enable") {
      if (action === "disable") {
        element.setAttribute("data-status", 0);
        return;
      }

      element.setAttribute("data-status", 1);
      return;
    }

    hideAllSecondaryTabs() {
      this.allSecondaryControls.forEach((secondaryControl) =>
        this.toggleSecondaryControl(secondaryControl, "hide")
      );
    }

    deactivateAllSecondaryTabs() {
      this.allSecondaryTabs.forEach((secondaryTab) =>
        this.toggleSecondaryTabActiveness(secondaryTab, "disable")
      );
    }

    deactivateAllMainControls() {
      this.mainControls.forEach((mainControl) =>
        this.toggleMainControl(mainControl, "disable")
      );
    }

    hideAllContent() {
      this.allContent.forEach((content) => this.toggleContent(content, "hide"));
    }
  }

  customElements.define("collection-cta", CollectionCta);
}

doCollectionCta();
